import clsx from "clsx"
import type { ReactNode } from "react"

import type { SX } from "../../theme"
import { Icon, type IconName } from "../Icon"
import { Text } from "../Text"
import styles from "./UnorderedList.module.css"

export interface UnorderedListProps {
  children?: ReactNode
  density?: "regular" | "compact"
  sx?: SX
}

export function UnorderedList(props: UnorderedListProps) {
  const { children, density = "regular", sx } = props

  return (
    <ul className={clsx(styles.list, styles[`density-${density}`])} style={sx}>
      {children}
    </ul>
  )
}

export interface ListItemProps {
  children?: ReactNode
}

export function ListItem(props: ListItemProps) {
  const { children } = props

  return (
    <li className={styles.item}>
      <Text component="span">{children}</Text>
    </li>
  )
}

interface IconListItemProps extends ListItemProps {
  icon?: IconName
}

export function IconListItem(props: IconListItemProps) {
  const { children, icon = "check" } = props

  return (
    <li className={clsx(styles.item, styles.iconItem)}>
      <Icon name={icon} size="medium" color="purple9" />
      <Text component="span">{children}</Text>
    </li>
  )
}
